import { Component, OnInit, Input } from '@angular/core';
import { Flow } from '../obj/Flow';
import { FlowManagementService } from '../services/flow-management.service';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-flow-tags',
    templateUrl: './flow-tags.component.html',
    styleUrls: ['./flow-tags.component.scss'],
    standalone: false
})
export class FlowTagsComponent implements OnInit {

  constructor(
    private flowManagementService: FlowManagementService,
    public dialog: DialogRef
  ) { }

  @Input() flow: Flow;
  description: string;
  tags: string[];
  newTag: string = '';
  flowData: any;
  isSaving: boolean = false;

  @Input() flowTags: string[];

  ngOnInit() {
    this.flowManagementService.getFlow(this.flow.environment, this.flow.flowName).toPromise().then(flow => {
      this.flowData = flow;
      this.description = this.flowData.properties.definitionSummary['description'] || '';
      this.tags = this.description.split(/\s+/).filter(x => x[0] == '#').map(x => x.toLowerCase());


    });
  }

  deleteTag(tag: string) {
    this.tags = this.tags.filter(item => item != tag);
  }

  addTag() {
    this.newTag = this.newTag.replace('#', '').replace(/\s+/, '');
    if (this.newTag == '') {
      return;
    }
    this.tags.push('#' + this.newTag);
    this.newTag = '';
  }

  fixTag(tag) {
    tag = tag.replace('#', '').replace(/\s+/, '');
    if (!tag) return null;

    return tag.startsWith('#') ? tag : `#${tag}`;
  }

  async saveTags() {

    try {
      this.isSaving = true;

      // build new description
      if (this.newTag) {
        this.addTag();
      }
      var newDescription = '';

      var oldWords = this.description.split(/\s+/);
      var firstTag = '';
      for (var i = oldWords.length - 1; i >= 0; i--) {
        if (oldWords[i][0] == '#') {
          firstTag = oldWords[i];
        }
        else {
          break;
        }
      }
      newDescription = this.description;
      if (firstTag) {
        // keep description up to firsttag
        var i = this.description.lastIndexOf(firstTag);
        newDescription = this.description.substring(0, i - 1);
      }
      newDescription += ' ' + this.tags.join(' ');

      this.flow.description = newDescription;

      this.flowManagementService.updateFlowDescription(this.flow).then(() => {
        this.close();
        //this.isSaving = false;
      });

    }
    catch {
    }
    finally {
      this.isSaving = false;
    }
  }

  public close() {
    if (this.dialog) {
      this.dialog.close();
    }
  }

  public onTagsChange(value: string[]) {
    this.tags = value.map(this.fixTag).filter(tag=>!!tag);
  }

  // public multiFilters(tags: string[]): string[] {
  //   return tags.map(( value ) => value);
  // }

}
